:host {
  display: block;
  width: inherit;
  min-width: 300px;
  height: inherit;
  min-height: 32px;
  background-color: var(--color-surface01);
}

:host > div {
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: var(--z-book-card-app-padding-y, calc(var(--space-unit) * 1.5))
    var(--z-book-card-app-padding-x, var(--space-unit));
  gap: calc(var(--space-unit) * 2);
}

:host > div .app {
  display: flex;
  flex: 1;
  align-items: center;
  gap: var(--space-unit);
}

:host > div .app.z-link {
  color: inherit;
  text-decoration: none;
}

:host > div .app.z-link:focus {
  text-decoration: none;
}

:host > div .app img {
  width: 1.5rem;
  height: 1.5rem;
  min-height: 32px;
}

:host > div .app .name {
  display: -webkit-box;
  overflow: hidden;
  height: 1.4rem;
  -webkit-box-orient: vertical;
  font-family: var(--font-family-serif);
  -webkit-line-clamp: 1;
  line-clamp: 1;
  text-overflow: ellipsis;
  word-break: break-all;
}

:host > div .app .name .laz {
  color: var(--red500);
}

:host > div z-info-reveal {
  --z-info-reveal-panel-width: 250px;
  --trigger-icon-size-x-small: 1rem;

  font-family: var(--font-family-sans);

  --color-surface05: var(--color-surface01);
  --color-text-inverse: var(--color-default-text);
  --color-inverse-icon: var(--color-primary01);
}

:host z-icon {
  --z-icon-width: 1rem;
  --z-icon-height: 1rem;
}
